import { breakpoints } from '@citrite/web-ui-component';

export const hideGreetingsBreakpoint = '699px';
export const centerContentWidthPX = breakpoints.centerContentWidthPX;
export const maxContentWidthPX = breakpoints.maxContentWidthPX;
